import { ID, Response } from 'app/components/Table/core/types';

import { getResponseError } from 'app/helpers/errors';

import { API_URL } from 'app/constants/environments';

import {
  StockRun,
  StockRunHistory,
  StockRunHistoryQueryResponse,
  StockRunItem,
  StockRunItemRequest,
  StockRunItemsQueryResponse,
  StockRunRequest,
  StockRunsQueryResponse,
} from './type';
import axios, { AxiosResponse } from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const STOCK_RUN_URL = `${API_URL}/api`;
const STOCK_RUN_ITEMS_URL = `${API_URL}/api`;

const getStockRuns = (
  query: string,
  _id?: ID,
  moreParam?: string,
): Promise<StockRunsQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run?${query}${moreParam || ''}`)
    .then(
      (
        d: AxiosResponse<{
          data: {
            items: Array<StockRun>;
            total: number;
          };
        }>,
      ) => {
        return {
          data: d.data.data,
        };
      },
    );
};

const getStockRun = (idStockRun: ID): Promise<StockRun | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run/${idStockRun}`)
    .then((response: AxiosResponse<Response<StockRun>>) => response.data)
    .then((response: Response<StockRun>) => response.data);
};

const createStockRun = (request: StockRunRequest): Promise<StockRun | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .post(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run`, request)
    .then((response: AxiosResponse<Response<StockRun>>) => response.data)
    .then((response: Response<StockRun>) => response.data);
};

const updateStockRun = (
  idStockRun: ID,
  request: StockRunRequest,
): Promise<StockRun | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .patch(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run/${idStockRun}`, request)
    .then((response: AxiosResponse<Response<StockRun>>) => response.data)
    .then((response: Response<StockRun>) => response.data);
};

const deleteStockRun = async (idStockRun: ID): Promise<void> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  try {
    await axios.delete(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run/${idStockRun}`);
  } catch (error) {
    console.log(`Error deleting stock run ${idStockRun}`);
    getResponseError(error);
    throw error;
  }
};
const getStockRunItems = (query: string, idStockRun: ID): Promise<StockRunItemsQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(
      `${STOCK_RUN_ITEMS_URL}/orgs/${organizationId}/stock-run-items/stock-run/${idStockRun}?${query}`,
    )
    .then(
      (
        d: AxiosResponse<{
          data: {
            items: Array<StockRunItem>;
            total: number;
          };
        }>,
      ) => {
        return {
          data: d.data.data,
        };
      },
    );
};
const getHistoryStockRunItems = (
  query: string,
  idStockRun: ID,
): Promise<StockRunHistoryQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run/${idStockRun}/history?${query}`)
    .then(
      (
        d: AxiosResponse<{
          data: {
            items: Array<StockRunHistory>;
            total: number;
          };
        }>,
      ) => {
        return {
          data: d.data.data,
        };
      },
    );
};

const createStockRunItem = (request: {
  items: StockRunItemRequest[];
  removeItems: number[];
}): Promise<StockRunItem[] | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .post(`${STOCK_RUN_ITEMS_URL}/orgs/${organizationId}/stock-run-items`, request)
    .then((response: AxiosResponse<Response<StockRunItem[]>>) => response.data)
    .then((response: Response<StockRunItem[]>) => response.data);
};

const updateStatusStockRun = (
  idStockRun: ID,
  request: { status: number },
): Promise<StockRunItem | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .patch(`${STOCK_RUN_URL}/orgs/${organizationId}/stock-run/${idStockRun}/status`, request)
    .then((response: AxiosResponse<Response<StockRunItem>>) => response.data)
    .then((response: Response<StockRunItem>) => response.data);
};

export {
  createStockRun,
  createStockRunItem,
  deleteStockRun,
  getHistoryStockRunItems,
  getStockRun,
  getStockRunItems,
  getStockRuns,
  updateStatusStockRun,
  updateStockRun,
};
